import { gql } from '@apollo/client';

/**
 * The platform's own configuration — what app_admin kept behind its cog.
 *
 * These read the tables the running backend reads: the app_config rows it
 * boots from, the fund houses it knows, the enums it hands every client, and
 * the rationale set the proposal flow offers. Staff-only, and the backend
 * enforces that independently of this app.
 */

/** Every app_config row, across environments. Values may come back redacted. */
export const LIST_APP_CONFIG = gql`
  query ListAppConfig {
    listAppConfig {
      key
      environment
      kind
      value
      valueType
      valueRedacted
      description
      updatedAt
      updatedBy
    }
  }
`;

/**
 * Every server-driven enum, with the label each value shows and the prompt the
 * agents are given for it. This is the single place those labels come from —
 * the KYC forms and the client screens all read them at runtime.
 */
export const GET_ALL_ENUM_METADATA = gql`
  query GetAllEnumMetadata {
    getAllEnumMetadata {
      enumName
      value
      displayValue
      description
      agentPrompt
      imageUrl
      updatedAt
    }
  }
`;

/**
 * The rationales a proposal can be filed under, by asset type and horizon.
 *
 * The same set the proposal builder offers — `runInvestmentAnalysis` takes a
 * rationale KEY from here, which is why editing this changes what the desk can
 * choose.
 */
export const GET_RATIONALE_OPTIONS = gql`
  query GetInvestmentRationaleOptions($assetType: String!, $horizonKey: String, $decision: String) {
    getInvestmentRationaleOptions(assetType: $assetType, horizonKey: $horizonKey, decision: $decision) {
      success
      assetType
      error
      horizons {
        horizonKey
        displayName
        horizonLabel
        horizonDescription
        horizonYearsMin
        horizonYearsMax
        monitoringFrequency
        rationales {
          id
          rationaleKey
          displayName
          description
          quickLabels
          sortOrder
          isActive
        }
      }
    }
  }
`;
